import { Button, Form, Input, Select, Switch, InputNumber } from "antd";
import { useState, useRef, useEffect } from "react";
import * as Validation from "../../../../../../../utils/helper/validation";
import * as Apis from "../../../../../../../utils/helper/enum";
import { changeLoader } from "../../../../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import { IoLocationOutline } from "react-icons/io5";
import config from "../../../../../../../config";

const mapContainerStyle = {
  height: "400px",
  width: "100%",
};

const libraries = ["places"];

const center = {
  lat: config.lat,
  lng: config.lng,
};

const BranchAddress = ({ branchDetail }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [markerPosition, setMarkerPosition] = useState(center);
  const [address, setAddress] = useState("");
  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [maxDistance, setMaxDistance] = useState(0);
  const [numberOfOrders, setNumberOfOrders] = useState(0);
  const [isFastestEnabled, setIsFastestEnabled] = useState(false);
  const inputRef = useRef(null);
  const geocoder = useRef(null);

  const [dropzones, setDropzones] = useState([]);

  const [vendorDetail, setVendorDetail] = useState([]);

  let { id, branchId } = useParams();

  const goBack = () => {
    localStorage.setItem("currentTab", "2");
    navigate("/edit-vendor/" + id);
  };

  const onLoadAutocomplete = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const location = place.geometry.location;
      setAddress(place.formatted_address);
      setMarkerPosition({
        lat: location.lat(),
        lng: location.lng(),
      });
    } else {
      //console.log("Autocomplete is not loaded yet!");
    }
  };

  const onMarkerDragEnd = (e) => {
    let newLat = e.latLng.lat();
    let newLng = e.latLng.lng();
    setMarkerPosition({
      lat: newLat,
      lng: newLng,
    });
    geocodeLatLng(newLat, newLng);
    handleInputChange("address");
  };
  const geocodeLatLng = (lat, lng) => {
    if (!geocoder.current) {
      geocoder.current = new window.google.maps.Geocoder();
    }

    const latLng = { lat, lng };
    geocoder.current.geocode({ location: latLng }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          setAddress(results[0].formatted_address);
          setInputValue(results[0].formatted_address); // Update the input field with the address
          form.setFieldValue("address", results[0].formatted_address);
        } else {
          // console.log("No results found");
        }
      } else {
        // console.log("Geocoder failed due to: " + status);
      }
    });
  };

  const handleSubmit = async (values) => {
    values.vendor_id = id;
    values.lat = markerPosition.lat;
    values.lng = markerPosition.lng;
    values.address = address;
    values.maxDistance = maxDistance;
    values.isFastestEnabled = isFastestEnabled ? 1 : 0;
    values.numberOfOrders = numberOfOrders;

    if (values.address === "") {
      form.setFields([
        {
          name: "address",
          errors: ["Please enter your Branch Address."],
        },
      ]);
      return false;
    }

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_VENDOR?.ADD_BRANCH;
      let method = "post";
      if (branchId) {
        url = Apis?.MANAGE_VENDOR?.EDIT_BRANCH + "/" + branchId;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Vendor created successfully";
        if (id) msg = "Vendor updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        localStorage.setItem("currentTab", "2");
        navigate("/edit-vendor/" + id);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getBranchDetail = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.BRANCH_DETAIL + "/" + branchId,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        form.setFieldValue("name", data?.name);
        let mobile = (data?.mobileNo).split("-");
        form.setFieldValue("mobile_no", mobile[1]);
        form.setFieldValue("building_no", data?.buildingNo);
        form.setFieldValue("floor_apartment", data?.floorApartment);

        form.setFieldValue(
          "associate_drop_zone",
          data?.dropzonedata?.id || null
        );
        form.setFieldValue("maxDistance", data?.maxDistance || 0);
        form.setFieldValue("numberOfOrders", data?.maximumFastestDeliveryOrders || 0);
        setMaxDistance(data?.maximumFastestDeliveryDistance || 0);
        setNumberOfOrders(data?.maximumFastestDeliveryOrders || 0);
        setIsFastestEnabled(data?.fastestDelivery === 1 ? true : false);

        setMarkerPosition({
          lat: data.lat,
          lng: data.lng,
        });
        setAddress(data.address);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getVendorDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.GET_VENDOR_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        setVendorDetail(data);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllDropzones = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.GET_ALL_DropZones,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.dropZoneLocales?.[0]?.name + ` (${item?.address})`,
            associateBranchId: item?.associateBranchId,
          };
        });
        setDropzones(data);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (branchId) getBranchDetail();
    getAllDropzones();
    getVendorDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  return (
    <>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        className="w-full"
        initialValues={{
          remember: true,
        }}
        autoComplete="off"
      >
        <div
          style={{
            maxWidth: 600,
            width: "100%",
          }}
        >
          <Form.Item
            label="Branch Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter your Branch Name.",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Mobile no"
            name="mobile_no"
            rules={[
              {
                required: true,
                message: "Please enter your Vendor mobile number.",
              },
              {
                min: 9,
                message: "Mobile number must be 9 digits",
              },
              {
                max: 9,
                message: "Mobile number must be no more than 9 digits",
              },
            ]}
            validateTrigger={"onSubmit"}
          >
            <Input
              size="large"
              addonBefore={<span>+966</span>}
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "number");
                form.setFieldValue("mobile_no", value.trimStart());
                handleInputChange("mobile_no");
              }}
            />
          </Form.Item>
          <Form.Item
            label="Building No"
            name="building_no"
            rules={[
              {
                required: true,
                message: "Please enter your building no.",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Floor Apartment"
            name="floor_apartment"
            rules={[
              {
                required: true,
                message: "Please enter your floor apartment.",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>

          {vendorDetail &&
          vendorDetail?.vendorDetail?.vendor_type !== "seller" ? (
            <Form.Item
              label="Associate Drop Zone"
              name="associate_drop_zone"
            >
              <Select
                allowClear
                size="large"
                placeholder="Select"
                options={dropzones}
                // options={dropzones.map((dropzone) => ({
                //   label: dropzone.label,
                //   value: dropzone.value,
                //   disabled: dropzone.associateBranchId > 0, // Disable if associateBranchId > 0
                // }))}
                onChange={(value) => {
                  form.setFieldValue("associate_drop_zone", value ?? 0);
                }}
                onClear={() => form.setFieldValue("associate_drop_zone", 0)}
                showSearch
                filterOption={(input, dropzones) =>
                  (dropzones?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </Form.Item>
          ) : null}

          <Form.Item
            label="Address"
            name="address"
            rules={[
              {
                required: branchId ? false : true,
                message: "Please enter your Branch Address.",
              },
            ]}
          >
            <div className="responsive-map-container mt-4">
              <LoadScript
                googleMapsApiKey={config.GOOGLEMAPAPIKEY}
                libraries={libraries}
              >
                <Autocomplete
                  onLoad={onLoadAutocomplete}
                  onPlaceChanged={onPlaceChanged}
                >
                  <div
                    className="hello "
                    style={{
                      width: "60%",
                      position: "absolute",
                      zIndex: "1",
                      top: "20px",
                      left: "110px",
                      right: "0",
                      margin: "auto",
                      padding: "10px",
                    }}
                  >
                    <Input
                      placeholder="Enter a location"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      ref={inputRef}
                    />
                  </div>
                </Autocomplete>

                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={markerPosition}
                  zoom={12}
                >
                  <Marker
                    position={markerPosition}
                    draggable={true}
                    onDragEnd={onMarkerDragEnd}
                  />
                </GoogleMap>
              </LoadScript>
              <div style={{ marginTop: "20px" }}>
                <h3 style={{ fontWeight: "bold", marginBottom: "12px" }}>
                  Street Address
                </h3>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <IoLocationOutline style={{ marginRight: "10px" }} />
                  {address}
                </p>
              </div>
             <div className="my-5 flex flex-col gap-3">
              <h3 style={{ fontWeight: "bold", marginBottom: "12px" }}>
                Delivery Type
              </h3>
              <p className="flex items-center gap-3 ">
                Fastest Delivery
                <Switch
                  checked={isFastestEnabled}
                  onChange={(checked) => {
                    setIsFastestEnabled(checked);
                  }}
                />
              </p>
              <span className="flex items-center gap-3">
                <p>Maximum Distance for fastest delivery</p>
                <InputNumber
                  style={{ width: "100px" }}
                  disabled={!isFastestEnabled}
                  min={0}
                  value={maxDistance}
                  onChange={(value) =>
                    !isFastestEnabled ? setMaxDistance(0) : setMaxDistance(value || 0)}
                />
              </span>
              <span className="flex items-center gap-3">
                <p>Maximum Number of orders for fastest delivery</p>
                <InputNumber
                  style={{ width: "100px" }}
                  disabled={!isFastestEnabled}
                  min={0}
                  value={numberOfOrders}
                  onChange={(value) => {
                     if (!isFastestEnabled) {
                        setNumberOfOrders(0)
                     }
                     setNumberOfOrders(value || 0)
                    }
                  }
                />
              </span>
             </div>
          </div>
          </Form.Item>
        </div>
        <div className="flex justify-end gap-3 w-full">
          <Button onClick={() => goBack()}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </div>
      </Form>
    </>
  );
};
export default BranchAddress;
